export enum PaymentGatewayName {
  stripe = 'stripe',
}
